














import { Component, Mixins } from "vue-property-decorator";
import { DocumentEditableMixin } from "../../mixins";
import { EditingDocument } from "../../EditingDocument";

@Component
export default class DocumentPageNavigator extends Mixins(DocumentEditableMixin) {
  get document(): EditingDocument {
    return this.editingSource;
  }

  set document(value: EditingDocument) {
    this.editingSource = value;
  }

  get isEnable(): boolean {
    return (1 < this.pageCount);
  }

  get isMovableToPreviousPage(): boolean {
    return this.isEnable
        && (1 < this.currentPage);
  }

  get isMovableToNextPage(): boolean {
    return this.isEnable
        && (this.currentPage < this.pageCount);
  }

  moveToPreviousPage(): void {
    if (this.isMovableToPreviousPage) {
      this.currentPage--;
    }
  }

  moveToNextPage(): void {
    if (this.isMovableToNextPage) {
      this.currentPage++;
    }
  }
}
